import React from 'react';
import { CatalogSource } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import { CarIcon } from 'assets/icons';
import { VerticalCenter } from 'pages/CatalogPage/common/CatalogHeader/CatalogHeader.styled';
import { theme } from 'styles';
import { Box, CenterFlex, Icon, Image, URL } from 'UI';

export const DefaultCarImage = ({
  isSmall,
  size,
  maxWidth,
  maxHeight,
}: {
  isSmall?: boolean;
  size?: number;
  maxWidth?: number;
  maxHeight?: number;
}) => {
  const imageSize = size ?? (isSmall ? 50 : 70);
  const resolvedWidth = maxWidth ?? imageSize;
  const resolvedHeight = maxHeight ?? imageSize;
  const getIconSize = (resolvedImageSize: number) => {
    if (resolvedImageSize <= 50) {
      return 30;
    }
    if (resolvedImageSize <= 70) {
      return 40;
    }
    return 48;
  };
  const iconSize = getIconSize(Math.min(resolvedWidth, resolvedHeight));
  return (
    <Box height={resolvedHeight} width={resolvedWidth} background={theme.color.grey95}>
      <CenterFlex>
        <Icon IconComponent={CarIcon} size={iconSize} color={theme.color.brand_black} noPointer />
      </CenterFlex>
    </Box>
  );
};

export const CarDetailHeaderImage = ({
  imageUrl,
  catalogSource,
  isSmall,
  size,
  maxWidth,
  maxHeight,
}: {
  imageUrl?: string;
  catalogSource: CatalogSource;
  isSmall: boolean;
  size?: number;
  maxWidth?: number;
  maxHeight?: number;
}) => {
  const imageSize = size ?? (isSmall ? 50 : 70);
  const resolvedMaxWidth = maxWidth ?? imageSize;
  const resolvedMaxHeight = maxHeight ?? imageSize;

  return (
    <VerticalCenter isSmall={isSmall} $size={size} $maxWidth={resolvedMaxWidth} $maxHeight={resolvedMaxHeight}>
      <Image
        src={imageUrl}
        type={URL}
        alt={'carPic'}
        maxWidth={resolvedMaxWidth}
        maxHeight={resolvedMaxHeight}
        catalogSource={catalogSource}
        fallbackComponent={
          <DefaultCarImage isSmall={isSmall} size={size} maxWidth={resolvedMaxWidth} maxHeight={resolvedMaxHeight} />
        }
      />
    </VerticalCenter>
  );
};
